document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('look-book-modal');
  const modalContent = document.getElementById('look-book-modal-content');
  const gridContainer = document.querySelector('.look-book-grid__container');
  const modalOverlay = modal.querySelector('.look-book-modal__overlay');
  const grid = document.getElementById('look-book-grid');

  let currentIndex = -1;

  if (grid && grid.classList.contains('look-book-grid--animate')) {
    grid.classList.add('is-visible');
  }

  function getLookItems() {
    return Array.from(document.querySelectorAll('.js-look-open'));
  }

  function openModal(index) {
    currentIndex = index;
    slideTo(index, 'next');

    setTimeout(() => {
      const scrollY = window.scrollY;
      modal.show();
      window.scrollTo({ top: scrollY });
      modal.classList.add('active');
      document.dispatchEvent(
        new CustomEvent('lookbookModal', {
          bubbles: true,
          detail: { modal: modalContent },
        }),
      );
      gridContainer.classList.add('fade-out', 'is-hidden');
    }, 500);
  }

  function closeModal() {
    const dialog = document.getElementById('look-book-modal');

    dialog.classList.remove('active');

    setTimeout(() => {
      if (dialog.open) dialog.close();
      modalContent.innerHTML = '';
      currentIndex = -1;
      gridContainer.classList.remove('fade-out', 'is-hidden');
    }, 400);
  }

  function slideTo(index, direction = 'next') {
    const postId = getLookItems()[index]?.dataset.postId;
    const hiddenTemplate = document.getElementById(`look-${postId}`);
    if (!hiddenTemplate) return;

    const currentArticle = modalContent.querySelector('.look-book-article__container');

    const tempWrapper = document.createElement('div');
    tempWrapper.innerHTML = hiddenTemplate.innerHTML;
    const newArticle = tempWrapper.querySelector('.look-book-article__container');
    modalContent.appendChild(newArticle);

    document.dispatchEvent(
      new CustomEvent('lookbookModal', {
        bubbles: true,
        detail: { modal: modalContent },
      }),
    );

    const newImage = newArticle.querySelector('.look-book-article__image-slide');
    const newGrid = newArticle.querySelector('.look-book-article__product-grid-container .look-book-article__slide');
    const oldImage = currentArticle?.querySelector('.look-book-article__image-slide');
    const oldGrid = currentArticle?.querySelector('.look-book-article__product-grid-container .look-book-article__slide');

    const inClass = direction === 'next' ? 'slide-in-from-right' : 'slide-in-from-left';
    const outClass = direction === 'next' ? 'slide-out-to-left' : 'slide-out-to-right';

    [newImage, newGrid].forEach((el) => el?.classList.add(inClass));

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        [newImage, newGrid].forEach((el) => el?.classList.add('active-slide-in'));
        [oldImage, oldGrid].forEach((el) => el?.classList.add(outClass));
      });
    });

    setTimeout(() => {
      if (currentArticle && currentArticle !== newArticle) {
        modalContent.removeChild(currentArticle);
      }
      newArticle.style.position = 'relative';
      bindInjectedModalEvents();
    }, 400);
  }

  function showPrev() {
    if (currentIndex > 0) {
      currentIndex--;
      slideTo(currentIndex, 'prev');
    }
  }

  function showNext() {
    if (currentIndex < getLookItems().length - 1) {
      currentIndex++;
      slideTo(currentIndex, 'next');
    }
  }

  function bindInjectedModalEvents() {
    modal.querySelector('.look-book-article__nav-arrow--left')?.addEventListener('click', showPrev);
    modal.querySelector('.look-book-article__nav-arrow--right')?.addEventListener('click', showNext);

    const closeLink = modal.querySelector('[data-close-modal]');
    closeLink?.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });

    const lookOpens = modal.querySelectorAll('.js-look-open');
    lookOpens.forEach((item) => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const postId = this.dataset.postId;
        const index = getLookItems().findIndex((el) => el.dataset.postId === postId);
        if (index !== -1) openModal(index);
      });
    });
    if (typeof window.ProductItem === 'function') {
      window.ProductItem(modalContent);
    }
  }

  getLookItems().forEach((item) => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const postId = this.dataset.postId;
      const index = getLookItems().findIndex((el) => el.dataset.postId === postId);
      if (index !== -1) openModal(index);
    });
  });

  modalOverlay?.addEventListener('click', closeModal);

  // Keyboard support
  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('active')) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowLeft') showPrev();
    if (e.key === 'ArrowRight') showNext();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const modalContent = document.querySelector('.look-book-article__container');
  const articlePage = document.querySelector('.look-book-article__page');

  if (modalContent) {
    document.dispatchEvent(
      new CustomEvent('lookbookModal', {
        bubbles: true,
        detail: { modal: modalContent },
      })
    );
  }

  if (articlePage) {
    articlePage.classList.add('active');
  }
});
